import { Lesson } from '../../../../types';
const lesson: Lesson = { itemId: '5234447', title: 'Aprenda e Lucre com nossos Sinais Ao Vivo', video: { platform: 'youtube', videoId: '2kPMUaj2DgM' }, article: ['Acesse nossa sala de sinais: <a href="https://t.me/trendingbrazil">https://t.me/trendingbrazil</a>'] };
export default lesson;

